export enum ExceptionAlertType {
  LOAD_REQUEST = 'LOAD_REQUEST',
  PROG_LOAD = 'PROG_LOAD',
  MISLOAD_GUR = 'MISLOAD_GUR',
  HSS_UNDER_WGT = 'HSS_UNDER_WGT',
}
